import React from 'react';

const useSourcesReload = ({activeView, loadSources}) => {
    const reloadActiveViewSilently = React.useCallback(() => (
        loadSources(activeView, {suppressError: true})
    ), [activeView, loadSources]);

    const reloadTimerRef = React.useRef(null);
    const scheduleReload = React.useCallback(() => {
        if (reloadTimerRef.current) {
            window.clearTimeout(reloadTimerRef.current);
        }

        reloadTimerRef.current = window.setTimeout(() => {
            reloadActiveViewSilently().catch(() => {
            });
            reloadTimerRef.current = null;
        }, 300);
    }, [reloadActiveViewSilently]);

    React.useEffect(() => () => {
        if (reloadTimerRef.current) {
            window.clearTimeout(reloadTimerRef.current);
        }
    }, []);

    return {
        reloadActiveViewSilently,
        scheduleReload,
    };
};

export default useSourcesReload;
